import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle, ArrowLeft } from "lucide-react";
import { Card, CardBody } from "@/components/ui/Card";
import { api } from "@/lib/api";
import TournamentNew, { draftFromInput } from "./TournamentNew";

export default function TournamentEdit() {
  const { slug = "" } = useParams();

  const q = useQuery({
    queryKey: ["tournament", slug],
    queryFn: () => api.getTournament(slug),
    enabled: Boolean(slug),
    staleTime: 0,
    refetchOnMount: "always",
  });

  if (q.isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <div>
          <Link
            to={`/tournaments/${slug}`}
            className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Torna al torneo
          </Link>
        </div>
        <Card>
          <CardBody className="text-sm text-slate-500">
            Carico i dati del torneo…
          </CardBody>
        </Card>
      </div>
    );
  }

  if (q.isError || !q.data) {
    return (
      <div className="flex flex-col gap-4">
        <div>
          <Link
            to="/tournaments"
            className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Tutti i tornei
          </Link>
        </div>
        <Card>
          <CardBody className="flex items-start gap-2 text-sm text-red-700">
            <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
            <div>
              Impossibile caricare il torneo "{slug}".
              <div className="text-xs text-red-600 mt-1">
                {String(
                  (q.error as { body?: { detail?: string } })?.body?.detail ??
                    q.error ??
                    "not found",
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }

  const detail = q.data;
  const initialDraft = draftFromInput(
    detail.input?.tournament ?? {},
    detail.input?.visual ?? null,
  );

  return <TournamentNew editSlug={slug} initialDraft={initialDraft} />;
}
